import React from 'react';

/**
 * A reusable toggle switch component
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.checked - Whether the switch is checked
 * @param {Function} props.onChange - Function to call when the switch is toggled
 * @param {string} [props.id] - Optional ID for the input
 * @param {string} [props.name] - Optional name for the input
 * @param {boolean} [props.disabled] - Whether the switch is disabled
 */
const ToggleSwitch = ({ checked = false, onChange, id, name, disabled = false }) => {
  // Ensure checked is always a boolean to avoid controlled/uncontrolled component warning
  const isChecked = checked === true || checked === false ? checked : false;
  
  // Handle change event - extract checked value from event
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.checked);
    }
  };

  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className="sr-only peer"
        id={id}
        name={name}
        disabled={disabled}
      />
      <div className={`w-11 h-6 bg-secondary-300 peer-focus:outline-none peer-focus:ring-4 
        peer-focus:ring-primary/30 rounded-full peer 
        peer-checked:after:translate-x-full peer-checked:after:border-white 
        after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
        after:bg-white after:border-border after:border after:rounded-full 
        after:h-5 after:w-5 after:transition-all peer-checked:bg-primary
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      ></div>
    </label>
  );
};

export default ToggleSwitch;